import Workout from "../../../assets/images/jpeg/inpersonWorkout.jpg";
import CustomButton from "../../../components/CustomButton";
import { Link } from "react-router-dom";

import CONSTANTS from "../../../utils/constants/CONSTANTS";

const TopBanner = () => (
  <div className="corporate-top-banner">
    <div className="corporate-left">
      <h1 className="main-heading">Corporate Wellness</h1>
      <h3 className="heading">Corporate Wellness with a personal touch.</h3>
      <p className="corporate-text">
        For years, corporation have sought out wellness solutions that would appeal to the greatest number of people in
        ways that would provoke healthier habits among their workforce.
      </p>
      <p className="corporate-text">
        Traditionally, these programs would aim to provide a culture of wellness at the workplace. In today's world,
        "workplace" takes on many different forms - providing challenges that are tough for employers to navigate.
      </p>
      <p className="corporate-text">
        With an Omni-Active® Corporate Wellness program, we aim to personalize our approach in such a way that we can
        effect the individual employee by giving them access to their own personal trainer, right at their fingertips.
        Whether they want to workout on-site or at home on their own time, we provide guided access like no other
        wellness program. We've leveraged the latest technology with out industry leading mobile app to include
        everything that your company will need to launch and sustain a successful wellness initiative. It's time to meet
        your employees where they're at on their journey.
      </p>
      <div className="btn">
        <Link to="/contact">
          <CustomButton type={CONSTANTS.ROUNDED_TYPE}>Discover More</CustomButton>
        </Link>
      </div>
    </div>
    <div className="corporate-right">
      <img className="main-image" src={Workout} alt="" />
    </div>
  </div>
);
export default TopBanner;
